<template>
  <el-select
    v-model="page.selectedVal"
    :placeholder="placeholder"
    :multiple="multiple"
    :disabled="disabled"
    :size="size"
    :clearable="clearable"
    :collapse-tags="collapseTags"
    :multiple-limit="multipleLimit"
    @clear="handleClear"
  >
    <el-option v-for="(item, index) in page.dictList" :value="item.value" :key="index" :label="item.label" />
  </el-select>
</template>
<script setup>
import { defineProps, reactive, getCurrentInstance, computed, watch, defineEmits } from 'vue'
const props = defineProps({
  modelValue: { type: String },
  dictKey: { type: String, required: true }, //字典关键字
  dictType: { type: Number, default: 1 }, //字典类型:1系统字典 2.机构字典
  placeholder: { type: String, default: '请选择' },
  multiple: { type: Boolean, default: false }, //是否多选
  disabled: { type: Boolean, default: false }, //是否禁用
  size: { type: String }, //尺寸
  clearable: { type: Boolean, default: true }, //是否可关闭
  collapseTags: { type: Boolean, default: false },
  multipleLimit: { type: Number } //最大选择数
})
const emit = defineEmits(['update:modelValue', 'change', 'selectClear'])
const { proxy } = getCurrentInstance()
const page = reactive({
  selectedVal: null,
  dictList: []
})

const getData = async () => {
  page.dictList = []
  let orgId = props.dictType === 2 ? localStorage.getItem('orgId') : null
  let res = await proxy.$http.post('/app/custClient/dict/options', { type: props.dictKey, orgId: orgId })
  if (res.code === 0) {
    page.dictList =
      res.data.map((i) => {
        return {
          label: i.dictValue,
          value: i.dictCode.toString()
        }
      }) || []
  }
}
const handleClear = () => {
  emit('selectClear')
}
watch(
  () => props.dictKey,
  () => {
    getData()
  },
  { immediate: true }
)
watch(
  () => props.modelValue,
  (newVal) => {
    if (newVal && newVal !== '') {
      page.selectedVal = props.multiple ? newVal.split(',') : newVal
    } else {
      page.selectedVal = props.multiple ? [] : ''
    }
  },
  { immediate: true }
)
watch(
  () => page.selectedVal,
  (newVal) => {
    let res = ''
    if (newVal) {
      res = props.multiple ? newVal.join(',') : newVal
      if (res !== props.modelValue) {
        emit('update:modelValue', res)
        emit('change', res)
      }
    }
  }
)
</script>
